// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    getBundleForSymetrical: `/${BASE_URL_BIDDING_SERVICE}/root/instance-bundle/symetrical-bundle`,
};

const GetInstanceBundleForSymetricalBundle = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getBundleForSymetrical}`, { params }).then(callback).catch(error).finally(next);
};

export const RootInstanceBundleService = {
    GetInstanceBundleForSymetricalBundle,
};
